<template>
  <div>
    <SplashSectionHero/>
    <!--    <SplashSectionHowItWorks />-->
    <!--    <SplashSectionHowItWorks2 />-->
    <!--    <SplashSectionWheneverBet />-->
    <!--    <SplashSectionAvailableSportsAndBookmakers />-->

    <!--    <LandingImage />-->

    <!--    <FaqSection />-->

    <!--    <Hero2Section />-->

    <!--    <StartButtonSection />-->

        <HeaderLogo />

        <Footer />
  </div>
</template>

<script setup lang="ts">
import SplashSectionHero from '@/components/splash/SplashSectionHero.vue'
import {onMounted} from 'vue'
import HeaderLogo from "@/components/header/HeaderLogo.vue";
import Footer from "@/components/footer/Footer.vue";

onMounted(() => {
  window.scrollTo(0, 0)
})
</script>
